module.exports = __webpack_public_path__ + "img/684.eaab2383.png";